import { render, staticRenderFns } from "./legalItem.vue?vue&type=template&id=6d3c369a&scoped=true"
import script from "./legalItem.vue?vue&type=script&lang=js"
export * from "./legalItem.vue?vue&type=script&lang=js"
import style0 from "./legalItem.vue?vue&type=style&index=0&id=6d3c369a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c369a",
  null
  
)

export default component.exports